<div class="task">
  <div class="task-item task-item-{{tache.etat}}" [ngClass]="{'is-active': toggleSlideTask}"
    (dblclick)='requestModification()'>
    @if (!readonly) {
      <div class="checkboxes">
        <input [id]="getElementId()" type="checkbox" [checked]="Tache.estTerminee(tache)"
          (change)="toggleTacheCompletion()" />
        <label [for]="getElementId()"></label>
      </div>
    }
    <div class="task-item_content">
      <div class="task-item_title">{{tache.titre}}</div>
      <div class="task-item_categorie">{{getLibelleCategorie()}}</div>
      <div class="task-item_description">{{tache.description}}</div>
      @if (tache.date) {
        <div class="task-item_date">{{tache.date | date:'dd/MM/yyyy'}} @if (hasHeureDebut()) {
          <span>à
          {{getHeureDebut()}}</span>
        }</div>
      }
      <div class="task-item_liens">
        @if (liensPersonnes?.length>0) {
          <div class="task-item_liens_wrapper is-personne">
            <i class="icon icon-user1"></i>
            @for (personne of liensPersonnes; track personne) {
              <div class="task-item_liens_item">
                <span (mouseenter)="showTooltipFor(personne)" (mouseleave)="showTooltipFor(null)" (click)="navigate(personne.idOriginal, TypeLien.personne)">
                  {{personne.libelle}}
                </span>
                @if (tooltipDisplayed == personne) {
                  <app-lien-personne-details-tooltip [lien]="personne">
                  </app-lien-personne-details-tooltip>
                }
              </div>
            }
          </div>
        }
        @if (liensFormateurs?.length>0) {
          <div class="task-item_liens_wrapper is-formateur">
            <i class="icon icon-user-check"></i>
            @for (formateur of liensFormateurs; track formateur) {
              <div class="task-item_liens_item">
                <span (mouseover)="showTooltipFor(formateur)" (mouseleave)="showTooltipFor(null)" (click)="navigate(formateur.idOriginal, TypeLien.formateur)">
                  {{formateur.libelle}}
                </span>
                @if (tooltipDisplayed == formateur) {
                  <app-lien-formateur-details-tooltip [lien]="formateur">
                  </app-lien-formateur-details-tooltip>
                }
              </div>
            }
          </div>
        }
        @if (liensEntreprises?.length>0) {
          <div class="task-item_liens_wrapper is-entreprise">
            <i class="icon icon-command"></i>
            @for (entreprise of liensEntreprises; track entreprise) {
              <div class="task-item_liens_item">
                <span (mouseover)="showTooltipFor(entreprise)"
                  (mouseleave)="showTooltipFor(null)"
                  (click)="navigate(entreprise.idOriginal, TypeLien.entreprise)">
                  {{entreprise.libelle}}
                </span>
                @if (tooltipDisplayed == entreprise) {
                  <app-lien-entreprise-details-tooltip [lien]="entreprise">
                  </app-lien-entreprise-details-tooltip>
                }
              </div>
            }
          </div>
        }
        @if (liensSessions?.length>0) {
          <div class="task-item_liens_wrapper is-session">
            <i class="icon icon-file-text"></i>
            @for (session of liensSessions; track session) {
              <div class="task-item_liens_item">
                <span (mouseover)="showTooltipFor(session)" (mouseleave)="showTooltipFor(null)" (click)="navigate(session.idOriginal, TypeLien.session)">
                  {{session.libelle}}
                </span>
                @if (tooltipDisplayed == session) {
                  <app-lien-session-details-tooltip [lien]="session">
                  </app-lien-session-details-tooltip>
                }
              </div>
            }
          </div>
        }
        @if (liensPersonnels?.length>0) {
          <div class="task-item_liens_wrapper is-personnel">
            <i class="icon icon-groups"></i>
            @for (personnel of liensPersonnels; track personnel) {
              <div class="task-item_liens_item">
                <span (mouseover)="showTooltipFor(personnel)" (mouseleave)="showTooltipFor(null)" (click)="navigate(personnel.idOriginal, TypeLien.personnel)">
                  {{personnel.libelle}}
                </span>
                @if (tooltipDisplayed == personnel) {
                  <app-lien-personnel-details-tooltip [lien]="personnel">
                  </app-lien-personnel-details-tooltip>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="task-item_more" *ifAuthorizedActif='FonctionLogicielle.Taches'>
      @if (!readonly) {
        <div class='e-caret-hide' ejs-dropdownbutton [items]='menu' (select)='doMenuAction($event)'>
          <i class='icon icon-more-vertical'></i>
        </div>
      }
    </div>
  </div>
</div>